import { ListingColDefs } from './listing-col-defs';

/**
 * Use this class to statically generate ag-grid column defs for the str listings grid
 */
export class StrColDefs extends ListingColDefs {
  licenseColumnFieldName = 'strLicense';

  licenseDisplayedColumnFieldName = 'strLicenseDisplayed';

  groupNodesWithCheckboxes = true;

  /**
   * Groups of columns for STR
   *
   * @override
   */
  columnGroups() {
    return [
      this.propertyDetailsColGroup,
      this.licenseComplianceColGroup,
      this.listingsInfoColGroup,
      this.occupancyComplianceColGroup,
      this.bedroomInfoColGroup,
      this.otherInfoColGroup,
      this.bookingInfoColGroup,
    ];
  }
}
